import { useEffect, useState } from "react";
import readMessageStream from "../../functions/requests/readMessageStream";
import IChatMessage from "../../types/interfaces/IChatMessage";
import { MessageRole } from "../../types/enums/MessageRole";
import ChatMessage from "./ChatMessage";
import { Box } from "@mui/material";
import IModel from "../../types/interfaces/IModel";

export type IncomingMessageStream = ReadableStream<Uint8Array>;

export type IncomingMessageProps = {
  stream: IncomingMessageStream | undefined;
  scrollCallback: () => void;
  model: IModel | undefined | null;
};

export default function IncomingMessage({
  stream,
  scrollCallback,
  model,
}: IncomingMessageProps) {
  const [content, setContent] = useState("");

  useEffect(() => {
    if (stream === undefined) return;
    if (stream.locked) return;
    
    // Get the basic model name
    const modelName = model?.internal_name || "";
    
    // For GPT-image models, include the original prompt in the model name parameter
    // by appending it after a colon separator: "gpt-image-1:draw a rainbow"
    let modelNameWithPrompt = modelName;
    if (modelName.includes("gpt-image")) {
      // Try to get the prompt from the last message (typically user's request)
      // This is a hack to pass the prompt through the chain for better display
      try {
        const lastContentHeader = document.querySelector('[data-testid="user-message"] .MuiTypography-root');
        if (lastContentHeader) {
          const prompt = lastContentHeader.textContent;
          if (prompt) {
            modelNameWithPrompt = `${modelName}:${prompt}`;
            console.log("Added original prompt to model name:", modelNameWithPrompt);
          }
        }
      } catch (e) {
        console.error("Failed to extract prompt from DOM:", e);
      }
    }
    
    readMessageStream(
      stream, 
      (token) => {
        setContent((prev) => prev + token);
        scrollCallback();
      },
      modelNameWithPrompt // Pass the enhanced model name with prompt
    )
      .then()
      .catch((_) => {});
  }, [stream, model, scrollCallback]);

  const chatMessage: IChatMessage = {
    id: "",
    conversationId: "",
    role: MessageRole.Assistant,
    content: content,
    updated: new Date(),
    model: model,
    hasFeedback: false,
  };
  return (
    <Box sx={{ width: "100%" }}>
      <ChatMessage fromUser={false} message={chatMessage} />
    </Box>
  );
}
